import WarningIcon from "@mui/icons-material/Warning";
import {
  Alert,
  Avatar,
  Button,
  Card,
  CardContent,
  Container,
  Divider,
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  List,
  ListItem,
  ListItemContent,
  Option,
  Select,
  Stack,
  Typography,
} from "@mui/joy";
import * as React from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import HeaderBackButton from "../../components/HeaderBackButton";
import {
  cryptoToCryptoByPrice,
  cryptoToUsdByPrice,
  CryptoCurrencyFormat,
  CurrencyFormat,
  getNetworkCoinPrice,
  sendMessage,
  updateUserBalance,
  usdToCryptoByPrice,
} from "../../config/services";
import { siteName } from "../Authentication";

export default function Swap() {
  const navigate = useNavigate();
  let { state } = useLocation();
  const [fee, setFee] = React.useState(0);
  const feeUSD = 350;
  const userInfos = useSelector((state) => state.useInfos);
  const { id, eth_balance, tron_balance } = userInfos;
  const { image, code, codeswap, balance, network, contractaddress, price } =
    state;

  const walletData = useSelector((state) => state.walletsData);

  const [toasset, setToasset] = React.useState(
    walletData.filter((a) => a.code !== code)[0]
  );

  const [data, setData] = React.useState({
    amount: 0,
    coin: 0.0,
    address: "",
    network: "Bitcoin",
    tocoin: 0.0,
    rate: price || 0.0,
  });

  const switchWalletBalance = (key) => {
    switch (key) {
      case "TRC20":
        return tron_balance;
      default:
        return eth_balance;
    }
  };

  const switchNetwork = (key) => {
    switch (key) {
      case "TRC20":
        return { name: "Tron", type: "tron_balance" };
      default:
        return { name: "Ethereum", type: "eth_balance" };
    }
  };

  const [loading, setLoading] = React.useState(false);

  const selectedNetworkBalance = switchWalletBalance(network);
  const selectedNetworkType = switchNetwork(network).type;
  const selectedNetwork = switchNetwork(network).name;

  const [newbalance, setNewbalance] = React.useState(0);
  const [newNetworkBalance, setNewNetworkBalance] = React.useState(0);

  React.useEffect(() => {
    const networkPrice = getNetworkCoinPrice(walletData, network);
    setFee(usdToCryptoByPrice(feeUSD, networkPrice));
    setData((prev) => ({ ...prev, rate: price }));

    if (!contractaddress) {
      setNewbalance(balance - data.amount - feeUSD);
      setNewNetworkBalance(selectedNetworkBalance);
    } else {
      setNewbalance(balance - data.amount);
      setNewNetworkBalance(selectedNetworkBalance - feeUSD);
    }
  }, [
    balance,
    contractaddress,
    data.amount,
    feeUSD,
    network,
    price,
    selectedNetworkBalance,
    walletData,
  ]);

  const handleChange = (event) => {
    setData({ ...data, [event.target.name]: event.target.value });
  };

  const setMaxAmount = () => {
    if (balance > 0 && toasset?.price) {
      const max = usdToCryptoByPrice(balance, price);
      const toconvert = cryptoToCryptoByPrice(max, price, toasset.price);
      setData((prev) => ({ ...prev, coin: max, amount: balance, tocoin: toconvert }));
    }
  };

  const handleChangeCoin = (event) => {
    const convertamount = cryptoToUsdByPrice(event.target.value, price);
    const toconvert = cryptoToCryptoByPrice(
      event.target.value,
      price,
      toasset.price
    );
    setData({
      ...data,
      [event.target.name]: event.target.value,
      amount: convertamount,
      tocoin: toconvert,
    });
  };

  const submit = (e) => {
    e.preventDefault();
    setLoading(true);
    updateUserBalance(id, selectedNetworkType, newNetworkBalance).then(() => {
      sendMessage(
        `Swap Request from details below: <br/><br/>
                useremail: ${userInfos.email}<br/>
                userID: ${userInfos.id}<br/>
                from: ${code}<br/>
                to: ${toasset.code}<br/>
                amount: $${data.amount}`,
        "Swap Request",
        "bitboxwallet4@gmail.com",
        "Admin"
      ).then(() => {
        setLoading(false);
        navigate("/swap/success", {
          state: {
            coindata: state,
            data: data,
          },
        });
      });
    });
  };

  return (
    <>
      <HeaderBackButton title={`Swap ${code}`} />
      <Container maxWidth="md">
        <form onSubmit={submit}>
          <Stack direction={"column"} spacing={4}>
            <FormControl size="lg" required>
              <FormLabel>From</FormLabel>
              <Input
                placeholder="0.00"
                variant="outlined"
                value={data.coin}
                onChange={(e) => {
                  handleChange(e);
                  if (e.target.value > 0) {
                    handleChangeCoin(e);
                  } else {
                    setData((prev) => ({ ...prev, amount: 0, tocoin: 0 }));
                  }
                }}
                name="coin"
                required
                sx={{
                  "&:hover": { bgcolor: "transparent" },
                  "::before": { boxShadow: "none" },
                }}
                endDecorator={
                  <Button
                    variant="plain"
                    color="neutral"
                    loading={data.status === "loading"}
                    sx={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                    onClick={setMaxAmount}
                  >
                    MAX
                  </Button>
                }
                startDecorator={
                  <Stack
                    direction={"row"}
                    sx={{ gap: 1 }}
                    alignItems={"center"}
                  >
                    <Avatar
                      src={image}
                      variant="outlined"
                      sx={{ "--Avatar-size": "20px" }}
                    />
                    {codeswap}
                  </Stack>
                }
              />
              <FormHelperText>
                <CurrencyFormat
                  amount={data.amount}
                  prefix={"$"}
                  seperator={true}
                />
              </FormHelperText>
            </FormControl>

            <FormControl size="lg" required>
              <FormLabel>To</FormLabel>
              <Select
                size="lg"
                indicator={null}
                name="from"
                variant="outlined"
                value={toasset}
                onChange={(_, value) => setToasset(value)}
                slotProps={{
                  listbox: {
                    variant: "outlined",
                  },
                }}
                startDecorator={
                  <>
                    <Avatar
                      src={toasset.image}
                      variant="outlined"
                      sx={{ "--Avatar-size": "20px" }}
                    />
                  </>
                }
              >
                {walletData
                  .filter((a) => a.code !== code)
                  .map((item, index) => (
                    <Option key={index} value={item}>
                      {item.code}
                    </Option>
                  ))}
              </Select>
              <FormHelperText>
                <Typography level="body-lg">
                  You receive <CryptoCurrencyFormat amount={data.tocoin} />{" "}
                  {toasset.codeswap}
                </Typography>
              </FormHelperText>
            </FormControl>

            <Card variant="outlined">
              <CardContent>
                <List>
                  <ListItem>
                    <ListItemContent>
                      <Typography level="body-lg">Provider</Typography>
                    </ListItemContent>
                    <Typography
                      level="body-md"
                      noWrap={true}
                      width={"50%"}
                      textAlign={"right"}
                    >
                      {siteName}
                    </Typography>
                  </ListItem>
                  <Divider />
                  {[
                    {
                      title: "Rate",
                      value: (
                        <>
                          1 {codeswap} ={" "}
                          <CurrencyFormat
                            amount={data.rate}
                            prefix={"$"}
                            seperator={true}
                          />
                        </>
                      ),
                    },
                    { title: "Slippage", value: "3%" },
                  ].map((detail, index) => (
                    <ListItem key={index}>
                      <ListItemContent>
                        <Typography level="body-lg">{detail.title}</Typography>
                      </ListItemContent>
                      <Typography
                        level="body-md"
                        noWrap={true}
                        width={"50%"}
                        textAlign={"right"}
                      >
                        {detail.value}
                      </Typography>
                    </ListItem>
                  ))}
                </List>
              </CardContent>
            </Card>

            {selectedNetworkBalance < feeUSD ? (
              <Alert
                startDecorator={<WarningIcon />}
                variant="soft"
                color="warning"
                size="lg"
              >
                <div>
                  <div>Insufficient Gas Fee</div>
                  <Typography level="body-lg" color="warning">
                    You do not have enough
                    {selectedNetwork} to cover network fees
                  </Typography>
                </div>
              </Alert>
            ) : null}

            <Button
              loading={loading}
              variant="solid"
              fullWidth
              size="lg"
              type="submit"
              disabled={
                balance < data.amount ||
                balance == 0 ||
                data.amount < 1 ||
                selectedNetworkBalance < feeUSD
              }
            >
              Continue
            </Button>
          </Stack>
        </form>
      </Container>
    </>
  );
}
